import { HINT_LENGTH_LIMITS } from "../constants";

/**
 * 返回提示詞最大字數限制（所有語言統一上限）
 * @returns 最大字數限制
 */
export const getHintMaxLength = (): number => {
    return HINT_LENGTH_LIMITS.MAX;
};
